import { render, staticRenderFns } from "./lkuSalesTdpcr.vue?vue&type=template&id=45588c56"
import script from "./lkuSalesTdpcr.vue?vue&type=script&lang=js"
export * from "./lkuSalesTdpcr.vue?vue&type=script&lang=js"
import style0 from "./lkuSalesTdpcr.vue?vue&type=style&index=0&id=45588c56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports